import React from "react";
import Icon from "../Icon/Icon";

import switchIcon from "icons/switch.svg";

export default class CurrencySwitch extends React.PureComponent {
  onSwitch = () => {
    const { from, to, onChange } = this.props;
    onChange(to, from);
  }

  render() {
    const { from, to } = this.props;
    return (
      <div className="currency-switch">
        <div className="currency-switch__field">
          {from}
        </div>
        <button type="button" className="currency-switch__button" onClick={this.onSwitch}>
          <Icon glyph={switchIcon} />
        </button>
        <div className="currency-switch__field">
          {to}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/CurrencySwitch/CurrencySwitch.jsx